import React, { useState } from "react";
import { Row, Col, Card, Statistic } from "antd";
import {
  ScheduleOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

const ReceptionistDashboard = () => {
  // Static/demo data
  const [stats] = useState({
    totalBookings: 120,
    pendingBookings: 35,
    completedBookings: 80,
  });

  // Light background colors
  const cardStyles = {
    total: { backgroundColor: "#e6f0ff", borderRadius: 8 },
    pending: { backgroundColor: "#fff7e6", borderRadius: 8 },
    completed: { backgroundColor: "#e6ffed", borderRadius: 8 },
  };

  return (
    <div style={{ padding: "24px" }}>
      <h2 style={{ marginBottom: 24 }}>Receptionist Dashboard</h2>

      <Row gutter={[24, 24]}>
        <Col xs={24} sm={12} md={8}>
          <Card style={cardStyles.total}>
            <Statistic
              title="Total Bookings"
              value={stats.totalBookings}
              valueStyle={{ color: "#3f51b5", fontWeight: "bold" }}
              prefix={<ScheduleOutlined />}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Card style={cardStyles.pending}>
            <Statistic
              title="Pending Bookings"
              value={stats.pendingBookings}
              valueStyle={{ color: "#faad14", fontWeight: "bold" }}
              prefix={<ClockCircleOutlined />}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Card style={cardStyles.completed}>
            <Statistic
              title="Completed Bookings"
              value={stats.completedBookings}
              valueStyle={{ color: "#52c41a", fontWeight: "bold" }}
              prefix={<CheckCircleOutlined />}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ReceptionistDashboard;
